import color from "../../../../constants/color";
import * as React from "react";
import { styled } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import { Typography, Select, MenuItem } from "@mui/material";
// import { useAlert } from "../../../context/AlertContext";
// const {showAlert} = useAlert();

const styles = {
  mainHeading: {
    fontSize: "20px",
    fontWeight: "600",
  },
  mainBox: {
    pt: "10px",
    m: "16px",
    width: "100%",
  },

  permissionText: {
    fontSize: "16px",
    fontWeight: "500",
    pt: "30px",
  },
  whiteSection: {
    m: "16px",
    backgroundColor: color.card,
    px: "20px",
    pb: "30px",
    borderRadius: "20px",
    display: "flex",
    justifyContent: "space-between",
    mt: 0,
  },
  employeeName: {
    width: "85%"
  },
  customHeading: {
    fontSize: "14px",
    fontWeight: "500",
    color: color.primary,

  },
  line: {
    borderBottom: "1px solid #28AA4A",
    mt: 2,

  },
  permissionLine: {
    border: "1.5px solid #28AA4A",
    width: "20px",
    mr: 1,
  },
  lineTextGrid: {
    display: "flex",
    alignItems: "center",
  },
  subheadingBox: {
    mt: 3,
    width: "fit-content",
  },
  permissionHeading: {
    fontSize: "14px",
    fontWeight: "500",

  },
  greyText: {
    color: color.lightText,
    fontSize: "12px",
    fontWeight: "400",
    mt: 1,
  },
  sectionGrid: {
    display: "flex",
    alignItems: "end",
    justifyContent: "space-between",
    mt: 3,
  },
  gridSubBox: {
    display: "flex",
    mt: 4,
    alignItems: "center",
    // justifyContent: "space-between",
  },
  condition: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
    ml: 1

  },
  mainBoxes: {
    m: "10px",
    px: "10px",
    display: "flex",
    mb: 3,
  },
  restoreButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "-8px",
    },

  },
  cancelButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#878787",
    fontSize: "14px",
    fontWeight: "500",
    ml: 3,
    px: 4,

  },
  radioContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  radioContainers: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ml: 5,
  },

  radioBtn: {
    m: 0,
    "& .css-wxwe5p-MuiButtonBase-root-MuiRadio-root": {
      padding: 0
    }
  }

}
export default styles


const BpIcon = styled("span")(() => ({
  borderRadius: "50%",
  width: 16,
  height: 16,
  backgroundColor: "#D9D9D9",
  "input:hover ~ &": {
    backgroundColor: "#D9D9D9",
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#28AA4A",
  backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&::before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: "''",
  },

  "input:hover ~ &": {
    backgroundColor: "#28AA4A",
  },
});

// Inspired by blueprintjs
function BpRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

export function CustomizedRadios({ onchange, isEdit, valueEdit, disabled, hideView = false }) {
  const handleRadioChange = (event) => {

    onchange(event.target.value);
  };
  return (
    <FormControl sx={{ width: { xs: "auto", md: "70%" } }}>
      <RadioGroup
        value={isEdit ? "edit" : "view"}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"
        disabled={disabled}
        onChange={handleRadioChange}
      >
        <Box sx={{ display: "flex", justifyContent: hideView ? "flex-start" : "space-between", mt: 2 }}>
          {!hideView && (
            <Box sx={styles.radioContainer}>
              <FormControlLabel defaultChecked={!isEdit} name="view" checked={!valueEdit} sx={styles.radioBtn} value="view" control={<BpRadio />} />
              <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Can View</Typography>
            </Box>
          )}
          <Box sx={hideView ? styles.radioContainer : styles.radioContainers}>
            <FormControlLabel defaultChecked={isEdit} name="edit" checked={valueEdit} sx={styles.radioBtn} value="edit" control={<BpRadio />} />
            <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Can Edit</Typography>
          </Box>
        </Box>
      </RadioGroup>
    </FormControl>
  );
}

// Attendance-specific radio component with 4 options: Can View, Can Edit (Self), Can Edit (Department), Can Edit (All)
export function AttendanceRadio({ onchange, value, disabled, departmentData, departments, onDepartmentsChange, departmentError }) {
  // value can be: "view", "editOwn", "editDept", "editAll"
  const handleRadioChange = (event) => {
    onchange(event.target.value);
  };
  return (
    <FormControl sx={{ width: { xs: "auto", md: "100%" } }}>
      <RadioGroup
        value={value || "view"}
        aria-labelledby="attendance-customized-radios"
        name="attendance-customized-radios"
        disabled={disabled}
        onChange={handleRadioChange}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2, gap: 3, flexWrap: "wrap", alignItems: "flex-start" }}>
          <Box sx={styles.radioContainer}>
            <FormControlLabel name="view" checked={value === "view"} sx={styles.radioBtn} value="view" control={<BpRadio />} />
            <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Can View</Typography>
          </Box>
          <Box sx={styles.radioContainer}>
            <FormControlLabel name="editOwn" checked={value === "editOwn"} sx={styles.radioBtn} value="editOwn" control={<BpRadio />} />
            <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Can Edit (Self)</Typography>
          </Box>
          <Box sx={styles.radioContainer}>
            <FormControlLabel name="editAll" checked={value === "editAll"} sx={styles.radioBtn} value="editAll" control={<BpRadio />} />
            <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Can Edit (All)</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, flexWrap: "wrap" }}>
            <Box sx={{ ...styles.radioContainer, mt: "7px" }}>
              <FormControlLabel name="editDept" checked={value === "editDept"} sx={styles.radioBtn} value="editDept" control={<BpRadio />} />
              <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Can Edit (Department)</Typography>
            </Box>
            {value === "editDept" && (
              <FormControl error={!!departmentError} sx={{ minWidth: { xs: "100%", sm: 260 }, maxWidth: { xs: "100%", sm: 340 } }}>
                <Select
                  multiple
                  value={departments || []}
                  onChange={(e) => onDepartmentsChange(e.target.value)}
                  displayEmpty
                  disabled={disabled}
                  sx={{ borderRadius: "10px", fontSize: "12px" }}
                  renderValue={(selected) =>
                    selected.length === 0
                      ? <Typography sx={{ fontSize: "12px", color: "#aaa" }}>Select Department(s)</Typography>
                      : selected.join(", ")
                  }
                >
                  {(departmentData || []).map((item, index) => (
                    <MenuItem key={index} value={item?.name}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
                {departmentError && (
                  <Typography sx={{ fontSize: "11px", color: "#d32f2f", mt: 0.5 }}>{departmentError}</Typography>
                )}
              </FormControl>
            )}
          </Box>
        </Box>
      </RadioGroup>
    </FormControl>
  );
}
